module.exports = __webpack_public_path__ + "static/media/buy-thumbnail.f29a87b0.png";